import React from 'react';
import { useRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { withLocale } from '../../../../../../utils/hocs';
import { sidebarState } from '../../../../../../utils/recoil/sidebar';
import { List } from '../../../../Navigation/List/list';
import { DrawerFloatingCloseButton } from '../../../../Overlays/Drawer/Drawer';
import { useDrawer } from '../../../../../../utils/recoil/drawer';

export const LanguageSettingsSwitcher = withLocale(
  ({ values, label, locale }) => {
    const drawer = useDrawer();
    const availableLangs = process.env.GATSBY_AVAILABLE_LANG.split(' ');
    return (
      <div className='px-6'>
        <div className='mb-2'>
          <Label
            {...label}
            size='2xl'
            weight='bold'
          />
        </div>
        <List
          listItems={availableLangs.map((lang) => {
            const language = values.find((val) => val.value === lang);
            if (language) {
              const isSelected = locale[0] === language.value;
              const onClick = () => {
                locale[1](language.value);
                drawer.close();
              };
              return {
                children: (
                  <button
                    type='button'
                    onClick={onClick}
                    className='hover:underline cursor-pointer'>
                    <Label
                      text={language.label?.text}
                      weight={isSelected ? 'bold' : 'normal'}
                      icon={{ iconKey: 'HiChevronRight' }}
                    />
                  </button>
                ),
                spacing: 'py-2',
              };
            }
          })}
        />
        <DrawerFloatingCloseButton />
      </div>
    );
  }
);

export const CurrencySettingsSwitcher = withLocale(
  ({ values, label, locale }) => (
    <div className='px-6'>
      <div className='mb-2'>
        <Label
          {...label}
          size='2xl'
          weight='bold'
        />
      </div>
      <List
        listItems={values.map((lang) => ({
          children: (
            <div
              onClick={() => locale[2](lang.value)}
              className='hover:underline cursor-pointer'>
              <Label
                text={lang.label?.text}
                icon={{ iconKey: 'HiChevronRight' }}
              />
            </div>
          ),
          spacing: 'py-2',
        }))}
      />
      <DrawerFloatingCloseButton />
    </div>
  )
);

export const PureBannerLanguageCurrencySwitch = withLocale(
  ({ language, currency, locale }) => {
    const drawer = useDrawer();
    const currentLanguage = language?.values.filter(
      (val) => val.value === locale[0]
    )[0];

    const handleLanguageSettingClick = () => {
      drawer.open({
        placement: 'left',
        width: 'w-96',
        title: null,
        body: <LanguageSettingsSwitcher {...language} />,
        footer: null,
        backdropLink: null,
      });
    };

    const handleCurrencySettingClick = () => {
      drawer.open({
        placement: 'left',
        width: 'w-96',
        title: null,
        body: <CurrencySettingsSwitcher {...currency} />,
        footer: null,
        backdropLink: null,
      });
    };

    return (
      <div className='flex items-center'>
        <button
          type='button'
          className='cursor-pointer hover:underline'
          onClick={handleLanguageSettingClick}>
          <Label
            truncate
            text={currentLanguage?.label?.text}
            icon={{ iconKey: 'FiChevronDown', color: 'white' }}
          />
        </button>
      </div>
    );
  }
);

export const BannerLanguageCurrencySwitch = (props) => (
  <PureBannerLanguageCurrencySwitch
    {...formatContentfulComponentProps(props)}
  />
);
